import React, { useState } from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import fileDownload from 'js-file-download'
import axios from 'axios'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect, Modal, DatePicker,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton,
} from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/mechanics-page/constants'
import { P } from '../../pages/mechanics-page/styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value} />
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
      {
        data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
      }
    </AntdSelect>
  )
}

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.OLD, text: statusText.OLD },
    { value: status.NEWS, text: statusText.NEWS },
    { value: status.LICENSE_EXPIRED, text: statusText.LICENSE_EXPIRED },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ปกติ"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_MECHANIC)}>
        <Link target="_blank" to={`/mechanic/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      {
        _.includes(window.perms, PERMISSION.CREATE_SALARY)
        && <Menu.Item key='salary' disabled={!_.includes(window.perms, PERMISSION.CREATE_SALARY)}>
          <Link target="_blank" to={`/mechanic/salary/${id}`}>
            บันทึกรายได้/ส่วนหักเงินเดือน
          </Link>
        </Menu.Item>
      }
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_MECHANIC)}>
        <Link target="_blank" to={`/mechanic/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

const ReportModal = ({
  props, isLoadingReport, setIsLoadingReport, reportModal, setReportModal, mechanic,
}) => {
  const [range, setRange] = useState([])
  return (
    <Modal
      title="พิมพ์รายงานช่าง"
      visible={reportModal}
      destroyOnClose={true}
      onCancel={() => {
        setReportModal(false)
        setRange([])
      }}
      onOk={() => {
        setIsLoadingReport(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/mechanic/repairjob?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `mechanicId=${props.match.params.id}`,
            ].join('&')
          }`,
        }).then((resp) => {
          fileDownload(resp.data, `รายงานช่าง ${(mechanic && mechanic.firstname) || ''} วันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} .xlsx`)
          setIsLoadingReport(false)
          setRange([])
          setReportModal(false)
        })
      }}
      okButtonProps={{
        loading: isLoadingReport,
      }}
      cancelButtonProps={{
        disabled: isLoadingReport,
      }}
    >
      <P margin='8px 0 16px 0'>เลือกวันที่</P>
      <DatePicker.RangePicker
        format='DD/MM/YYYY'
        onChange={(e) => {
          setRange(e)
        }}
      />
    </Modal>
  )
}

export const PaymentActionBar = ({
  loading, doAction, mutationVariables, props, disabled,
}) => {
  const [modal, setModal] = useState(false)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || !_.includes(window.perms, PERMISSION.CREATE_SALARY) || disabled}
        text='บันทึก'
        icon='fas fa-plus'
        inverse
        onClick={() => {
          doAction({
            variables: {
              ...mutationVariables,
            },
          }).then(({ data }) => {
            const resp = data.CreateMechanicSalary
            if (resp.success) {
              message.success(resp.message)
              history.push('/mechanic')
            } else message.error(resp.message)
          })
        }}
      />
    </Div>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, mechanic,
}) => {
  const [reportModal, setReportModal] = useState(false)
  const [isLoadingReport, setIsLoadingReport] = useState(false)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        text='พิมพ์รายงานช่าง'
        icon='fas fa-print'
        onClick={() => setReportModal(true)}
        margin='0 8px'
        loading={isLoadingReport}
        disabled={
          isAddMode
          || isLoadingReport
        }
      />
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_MECHANIC)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/mechanic/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateMechanic : data.UpdateMechanic
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/mechanic')
                // else {
                //   refetch()
                //   history.push(`/mechanic/view/${props.match.params.id}`)
                // }
              } else message.error(resp.message)
            })
          }
        }}
      />
      <ReportModal
        props={props}
        isLoadingReport={isLoadingReport}
        setIsLoadingReport={setIsLoadingReport}
        reportModal={reportModal}
        setReportModal={setReportModal}
        mechanic={mechanic}
      />
    </Div>
  )
}
